export const VALID_TAB = "VALID_TAB"

export const validTab = tab => dispatch => {
    dispatch({
        type: VALID_TAB,
        tab
    })
}
